import { createFileRoute } from '@tanstack/react-router';
import { CanaisView } from '@/modules/agentes/components/CanaisView';

export const Route = createFileRoute('/_authed/agentes_/$agente')({
  component: CanaisPage,
});

function CanaisPage() {
  const { agente } = Route.useParams();
  return <CanaisView agente={agente} />;
}
